import { BehaviorSubject ,  Subject } from 'rxjs';
import { Partner } from './models/partner';
import { User } from '../user/models/user';

export abstract class PartnerComponentBase {

    constructor() { }

    editModeSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public editModeObserver = this.editModeSubject.asObservable();

    refreshDataSubject: Subject<void> = new Subject<void>();
    public refreshDataObserver = this.refreshDataSubject.asObservable();

    reloadDataSubject: Subject<void> = new Subject<void>();
    public reloadDataObserver = this.reloadDataSubject.asObservable();

    public selectedPartner: Partner;

    setPartner(partner: Partner): Promise<any> {
        this.selectedPartner = partner;
        return this.partnerSet();
    }

    protected abstract partnerSet(): Promise<any>;

    protected setEditMode(isEditing: boolean) {
        this.editModeSubject.next(isEditing);
    }

    /**
     * Tell the search-result page to reload data.
     */
    protected refreshSearchData() {
        this.refreshDataSubject.next();
    }

    /**
     * Tell the details page to reload data.
     */
    protected reloadDetailsData() {
        this.reloadDataSubject.next();
    }

    public evaluatePermissions(permission: string, user: User, hasPermission: boolean, partner: Partner) {
        if (permission == 'Partner_Action_InternalPartner') {
            if (partner && partner.PartnerType && partner.PartnerType.Name != 'Internal') {
                // For non-internal partners, ignore the 'internal' permission by always granting it.
                hasPermission = true;
            }
        }
        return hasPermission;
    }
}
